import React, { useCallback, useMemo, useState } from 'react';
import { Button } from '@ui';
import SearchPanel from '@components/SearchPanel';
import { translate } from '@utils/i18n';
import { useQuestionSetQuestions } from '../../hooks/useQuestionSetQuestions';
import QuestionSetQuestionsTable from '../QuestionSetQuestionsTable';
import AddQuestionModal from '../AddQuestionModal';
import './QuestionsTabStyles.scss';
const namespace = 'features.settings.component_questions';
export default function QuestionsTab({ questionSetId }) {
    const [searchQuery, setSearchQuery] = useState('');
    const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
    // Fetch questions and options for this question set
    const { data, isLoading: isLoadingQuestions } = useQuestionSetQuestions(questionSetId);
    const questions = (data === null || data === void 0 ? void 0 : data.questions) || [];
    const options = data === null || data === void 0 ? void 0 : data.options;
    const handleSearchChange = useCallback((value) => {
        setSearchQuery(value);
    }, []);
    const handleAddQuestion = () => {
        setIsAddQuestionModalOpen(true);
    };
    const handleCloseAddQuestionModal = () => {
        setIsAddQuestionModalOpen(false);
    };
    const questionsContent = useMemo(() => {
        if (isLoadingQuestions) {
            return (React.createElement("div", { className: "questions-tab__loading" },
                React.createElement("i", { className: "fa fa-spinner fa-spin" }),
                " ",
                translate('loading', { namespace: 'features.commons' }),
                "..."));
        }
        if (questions.length === 0) {
            return (React.createElement("div", { className: "questions-tab__empty-state" },
                React.createElement("p", null, translate('no_questions', { namespace })),
                React.createElement(Button, { onClick: handleAddQuestion },
                    React.createElement("i", { className: "fa fa-plus" }),
                    " ",
                    translate('add_first_question', { namespace }))));
        }
        return React.createElement(QuestionSetQuestionsTable, { questions: questions, questionSetId: questionSetId, searchQuery: searchQuery });
    }, [isLoadingQuestions, questions, questionSetId, searchQuery]);
    return (React.createElement("div", { className: "questions-tab" },
        React.createElement("div", { className: "questions-tab__header" },
            React.createElement(SearchPanel, { placeholder: translate('search_questions_placeholder', { namespace }), onChange: handleSearchChange }),
            React.createElement(Button, { variant: "primary", onClick: handleAddQuestion },
                React.createElement("i", { className: "fa fa-plus" }),
                " ",
                translate('add_question', { namespace }))),
        questionsContent,
        isAddQuestionModalOpen && (React.createElement(AddQuestionModal, { isOpen: isAddQuestionModalOpen, onClose: handleCloseAddQuestionModal, questionSetId: questionSetId, options: options }))));
}
